import type { AdminContentConsent, AdminContentConsentListResult, PublishedApplicationDocument } from "@yahshi/contracts";
import { adminContentConsentListQuerySchema } from "@yahshi/contracts";
import type { ContentConsentApi } from "./ContentConsentApi";

type SeedConsent = {
  userId: string; userPublicId: string; userName: string;
  appId: string; appName: string; appCode: string;
  type: AdminContentConsent["type"]; agreedVersion: number; agreedAt: string;
};

const seed: SeedConsent[] = [
  { userId: "11111111-1111-4111-8111-111111111111", userPublicId: "1001", userName: "林默", appId: "app_yahshi_web", appName: "Yahshi Web", appCode: "yahshi-web", type: "user_agreement", agreedVersion: 2, agreedAt: "2026-09-15T02:18:00.000Z" },
  { userId: "55555555-5555-4555-8555-555555555555", userPublicId: "1005", userName: "程一", appId: "app_yahshi_web", appName: "Yahshi Web", appCode: "yahshi-web", type: "user_agreement", agreedVersion: 1, agreedAt: "2026-09-08T05:20:00.000Z" },
  { userId: "33333333-3333-4333-8333-333333333333", userPublicId: "1003", userName: "周野", appId: "app_yahshi_web", appName: "Yahshi Web", appCode: "yahshi-web", type: "privacy_policy", agreedVersion: 1, agreedAt: "2026-09-09T03:40:00.000Z" },
];

export function createDevelopmentContentConsentApi(options: {
  getPublished?: (appId: string, type: string) => Promise<PublishedApplicationDocument>;
} = {}): ContentConsentApi {
  return {
    async history() { throw new Error("历史回执需要连接测试服务，演示数据不提供真实同意证据"); },
    async list(query = {}): Promise<AdminContentConsentListResult> {
      const parsed = adminContentConsentListQuerySchema.parse(query);
      const rows: AdminContentConsent[] = [];
      for (const [index, item] of seed.entries()) {
        let currentVersion: number | null;
        let currentRevisionId: string | null = null;
        const agreedRevisionId = index === 0 ? "22222222-1111-4111-8111-aaaaaaaa0001" : index === 2 ? "22222222-1111-4111-8111-aaaaaaaa0002" : null;
        try {
          const published = await options.getPublished?.(item.appId, item.type);
          currentVersion = published?.version ?? null;
          currentRevisionId = published?.revisionId ?? null;
        } catch {
          currentVersion = null;
        }
        rows.push({
          id: `cns_demo_${index + 1}`, appId: item.appId, appName: item.appName, appCode: item.appCode,
          userId: item.userId, userPublicId: item.userPublicId, userName: item.userName,
          type: item.type, agreedVersion: item.agreedVersion, currentVersion,
          agreedRevisionId, currentRevisionId,
          current: agreedRevisionId !== null && agreedRevisionId === currentRevisionId,
          agreedAt: item.agreedAt, updatedAt: item.agreedAt,
        });
      }
      rows.sort((left, right) => right.agreedAt.localeCompare(left.agreedAt) || right.id.localeCompare(left.id));
      const keyword = parsed.keyword.trim().toLowerCase();
      const base = rows.filter((item) => {
        if (parsed.appId && item.appId !== parsed.appId) return false;
        if (parsed.type !== "all" && item.type !== parsed.type) return false;
        if (!keyword) return true;
        return `${item.userName} ${item.userPublicId} ${item.appName} ${item.appCode} ${item.id}`.toLowerCase().includes(keyword);
      });
      const scoped = base.filter((item) => {
        if (parsed.match === "current") return item.current;
        if (parsed.match === "stale") return item.currentVersion !== null && !item.current;
        if (parsed.match === "unavailable") return item.currentVersion === null;
        return true;
      });
      const offset = (parsed.page - 1) * parsed.pageSize;
      return {
        items: scoped.slice(offset, offset + parsed.pageSize),
        total: scoped.length,
        summary: {
          total: base.length,
          current: base.filter((item) => item.current).length,
          stale: base.filter((item) => item.currentVersion !== null && !item.current).length,
          unavailable: base.filter((item) => item.currentVersion === null).length,
        },
      };
    },
  };
}
